/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBrightnessHigh = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm6-10v3h-2V2h2zm0 17v3h-2v-3h2zM2 11h3v2H2v-2zm17 0h3v2h-3v-2zM5.636 4.222l2.121 2.121-1.414 1.414-2.121-2.121 1.414-1.414zm12.021 12.021 2.121 2.121-1.414 1.414-2.121-2.121 1.414-1.414zM4.222 18.364l2.121-2.121 1.414 1.414-2.12 2.121-1.415-1.414zM16.243 6.343l2.121-2.121 1.414 1.414-2.121 2.121-1.414-1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBrightnessHigh as BrightnessHigh };
